import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { RouterModule } from "@angular/router";

import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LandingComponent } from "./components/landing/landing.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { ExpandableSectionComponent } from "./components/controls/expandable-section/expandable-section.component";
import { AdminComponent } from "./components/admin/admin.component";
import { AccessGuard } from "./guards/access.guard";
import { CertificateRequestFormComponent } from "./components/admin/certificate-request-form/certificate-request-form.component";
import { LoginComponent } from "./components/landing/login/login.component";
import { CertificateIssueComponent } from "./components/certificate-issue/certificate-issue.component";
import { CertificateInstructionsComponent } from "./components/certificate-issue/certificate-instructions/certificate-instructions.component";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    NotFoundComponent,
    ExpandableSectionComponent,
    AdminComponent,
    CertificateRequestFormComponent,
    LoginComponent,
    CertificateIssueComponent,
    CertificateInstructionsComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatToolbarModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    RouterModule.forRoot(
      [
        { path: "", component: LandingComponent },
        { path: "login", component: LoginComponent },
        {
          path: "issue",
          component: CertificateIssueComponent,
          canActivate: [AccessGuard],
          data: {
            accessRequired: ["IssuedCertificate"],
            fallbackRoute: "/admin",
          },
        },
        {
          path: "admin",
          component: AdminComponent,
          canActivate: [AccessGuard],
          data: {
            accessRequired: ["CertificateAdmin"],
            fallbackRoute: "/LoginError",
          },
        },
        { path: "**", component: NotFoundComponent },
      ],
      {}
    ),
    BrowserAnimationsModule,
  ],
  providers: [AccessGuard, provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent],
})
export class AppModule {}
